<h4 class="mt-2 mb-4" [class.bg-warning]="form && form.lastApproved && form.lastApproved.name !== form.name">Datenschutzerklärung für das Formular {{form?.name}}</h4>

<p>gemäß Art. 13 EU-Datenschutz-Grundverordnung (DSGVO)</p>
<p>Stand: {{form?.timestamp | date:'dd.MM.yyyy'}}</p>

<p class="fw-bold">Verantwortlicher für die Datenverarbeitung</p>
<p>Verantwortlicher im Sinne der EU-Datenschutz-Grundverordnung (DSGVO) und anderer nationaler Datenschutzgesetze sowie sonstiger datenschutzrechtlicher Bestimmungen ist der:</p>
<p class="ps-3">
  Rundfunk Berlin-Brandenburg (rbb)<br>
  vertreten durch die Intendantin<br>
  Anstalt des öffentlichen Rechts<br>
  Masurenallee 8-14<br>
  14057 Berlin
</p>


<p class="fw-bold">Kontakt und Auskunft in Datenschutzfragen</p>
<p>Datenschutzbeauftragte des rbb ist:</p>
<p class="ps-3">
  Nicoleta-Simina Constantin<br>
  Masurenallee 8-14<br>
  14057 Berlin<br>
  E-Mail: <a target="_blank" href="mailto:datenschutz@rbb-online.de">datenschutz&#64;rbb-online.de</a>
</p>



<p class="fw-bold">Zweck der Datenverarbeitung</p>
<p [innerHTML]="prepareLink(form?.privacyReason)" [class.bg-warning]="form && form.lastApproved && form.lastApproved.privacyReason !== form.privacyReason"></p>



<p class="fw-bold">Verarbeitete Daten</p>
<p>Die über das Formular erhobenen Daten werden unter der Beachtung der EU-Datenschutz-Grundverordnung (DSGVO) verarbeitet. Es werden folgende personenbezogene Daten verarbeitet:</p>
@if (form?.dataFieldsCustomParameter) {
  <ul [class.bg-warning]="form && form.lastApproved && form.lastApproved.dataFieldsCustomParameter !== form.dataFieldsCustomParameter">
    <li>Vorname</li>
    <li>Nachname</li>
    <li>AD Benutzername</li>
    <li>ARD UID</li>
    <li>E-Mail-Adresse</li>
    @if (checkTypeInField('EMPLOYEE_NUMBER')) {<li>Personalnummer</li>}
    @if (checkTypeInField('EMPLOYEE_TYPE')) {<li>Vertragsart</li>}
    @if (checkTypeInField('MOBILE_WORK_AGREEMENT')) {<li>Vereinbarung für mobiles Arbeiten</li>}
    @if (checkTypeInField('DISABILITY_STATUS')) {<li>Schwerbehinderung</li>}
    @if (checkTypeInField('ORG_UNIT')) {<li>Bereich/Abteilung</li>}
    @if (checkTypeInApprover('CHIEF') || checkTypeInApprover('CHIEF_AND_DEPUTY')) {<li>Vorgesetzter (Vorname, Nachname, AD Benutzername, ARD UID, E-Mail-Adresse)</li>}
    @if (checkTypeInApprover('CHIEF_AND_DEPUTY')) {<li>Stellvertretender Vorgesetzter (Vorname, Nachname, AD Benutzername, ARD UID, E-Mail-Adresse)</li>}
    @if (checkTypeInField('COST_CENTRE') || checkTypeInApprover('COST_CENTRE_RESPONSIBLE') || checkTypeInApprover('COST_CENTRE_RESPONSIBLE_AND_DEPUTY')) {<li>Kostenstelle</li>}
    @if (checkTypeInApprover('COST_CENTRE_RESPONSIBLE') || checkTypeInApprover('COST_CENTRE_RESPONSIBLE_AND_DEPUTY')) {<li>Kostenstellenverantwortlicher (Vorname, Nachname, AD Benutzername, ARD UID, E-Mail-Adresse)</li>}
    @if (checkTypeInApprover('COST_CENTRE_RESPONSIBLE_AND_DEPUTY')) {<li>Stellvertretender Kostenstellenverantwortlicher (Vorname, Nachname, AD Benutzername, ARD UID, E-Mail-Adresse)</li>}
    @if (checkTypeInApprover('DEPARTMENT_CHIEF') || checkTypeInApprover('DEPARTMENT_CHIEF_AND_DEPUTY')) {<li>Abteilung</li>}
    @if (checkTypeInApprover('DEPARTMENT_CHIEF') || checkTypeInApprover('DEPARTMENT_CHIEF_AND_DEPUTY')) {<li>Abteilungsleiter (Vorname, Nachname, AD Benutzername, ARD UID, E-Mail-Adresse)</li>}
    @if (checkTypeInApprover('DEPARTMENT_CHIEF_AND_DEPUTY')) {<li>Stellvertretender Abteilungsleiter (Vorname, Nachname, AD Benutzername, ARD UID, E-Mail-Adresse)</li>}
    @if (checkTypeInApprover('MAIN_DEPARTMENT_CHIEF') || checkTypeInApprover('MAIN_DEPARTMENT_CHIEF_AND_DEPUTY')) {<li>Hauptabteilung</li>}
    @if (checkTypeInApprover('MAIN_DEPARTMENT_CHIEF') || checkTypeInApprover('MAIN_DEPARTMENT_CHIEF_AND_DEPUTY')) {<li>Hauptabteilungsleiter (Vorname, Nachname, AD Benutzername, ARD UID, E-Mail-Adresse)</li>}
    @if (checkTypeInApprover('MAIN_DEPARTMENT_CHIEF_AND_DEPUTY')) {<li>Stellvertretender Hauptabteilungsleiter (Vorname, Nachname, AD Benutzername, ARD UID, E-Mail-Adresse)</li>}
    @if (checkTypeInApprover('DIRECTOR') || checkTypeInApprover('DIRECTOR_AND_DEPUTY')) {<li>Direktion</li>}
    @if (checkTypeInApprover('DIRECTOR') || checkTypeInApprover('DIRECTOR_AND_DEPUTY')) {<li>Direktor (Vorname, Nachname, AD Benutzername, ARD UID, E-Mail-Adresse)</li>}
    @if (checkTypeInApprover('DIRECTOR_AND_DEPUTY')) {<li>Stellvertretender Direktor (Vorname, Nachname, AD Benutzername, ARD UID, E-Mail-Adresse)</li>}
    @if (checkTypeInField('ROOM')) {<li>Raumnummer</li>}
    @if (checkTypeInField('ROOM')) {<li>Gebäudename</li>}
    @if (checkTypeInField('ROOM')) {<li>Gebäudeabkürzung</li>}
    @if (checkTypeInField('ROOM')) {<li>Etage</li>}
    @if (checkTypeInField('TELEPHONE')) {<li>Telefonnummer</li>}
    @if (checkTypeInField('FAX')) {<li>Faxnummer</li>}
    @if (checkTypeInField('MOBILE')) {<li>Mobilfunknummer</li>}
    @if (checkTypeInField('FILESERVICE') || checkTypeInField('APPLICATION') || checkTypeInField('PROJECT') || checkTypeInField('CAD') || checkTypeInField('CONFLUENCE') || checkTypeInField('GENERAL') || checkTypeInField('IT') || checkTypeInField('JIRA') || checkTypeInField('BIMEDIAL') || checkTypeInField('MCLOUD') || checkTypeInField('MUSIC_MASTER') || checkTypeInField('RABBIT')) {<li>Applikationen (+ dazugehörige Rollen, Gruppen, Projekte oder Bereiche)</li>}
    @for (dataField of (form?.dataFieldsCustomParameter ?? []); track dataField) {
      <li>{{dataField}}</li>
    }
  </ul>
}


<p class="fw-bold">Datenquellen</p>
<p>Die verarbeiteten Daten werden hauptsächlich über das Ausfüllen des Formulars erhoben. Zur Unterstützung beim Ausfüllen und Überprüfung der Richtigkeit werden folgende Daten aus anderen Systemen abgerufen.</p>



<p class="text-underline">Active Directory für die Anmeldung</p>
<ul>
  <li>Vorname</li>
  <li>Nachname</li>
  <li>AD Benutzername</li>
  <li>ARD UID</li>
  <li>E-Mail-Adresse</li>
</ul>



@if (checkTypeInField('ORG_UNIT') || checkTypeInField('COST_CENTRE') || checkTypeInField('EMPLOYEE_TYPE') || checkTypeInField('EMPLOYEE_NUMBER') || checkTypeInField('MOBILE_WORK_AGREEMENT') || checkTypeInField('DISABILITY_STATUS') || checkTypeInApprover('CHIEF') || checkTypeInApprover('CHIEF_AND_DEPUTY') || checkTypeInApprover('COST_CENTRE_RESPONSIBLE') || checkTypeInApprover('COST_CENTRE_RESPONSIBLE_AND_DEPUTY') || checkTypeInApprover('DEPARTMENT_CHIEF') || checkTypeInApprover('DEPARTMENT_CHIEF_AND_DEPUTY') || checkTypeInApprover('MAIN_DEPARTMENT_CHIEF') || checkTypeInApprover('MAIN_DEPARTMENT_CHIEF_AND_DEPUTY') || checkTypeInApprover('DIRECTOR') || checkTypeInApprover('DIRECTOR_AND_DEPUTY') || checkTypeInApprover('DESIGNATED_APPROVER')) {
  <p class="text-underline">Zyrus</p>
  <ul>
    <li>Vorname</li>
    <li>Nachname</li>
    <li>AD Benutzername</li>
    <li>ARD UID</li>
    <li>E-Mail-Adresse</li>
    @if (checkTypeInField('EMPLOYEE_NUMBER')) {<li>Personalnummer</li>}
    @if (checkTypeInField('EMPLOYEE_TYPE')) {<li>Vertragsart</li>}
    @if (checkTypeInField('MOBILE_WORK_AGREEMENT')) {<li>Vereinbarung zum mobilen Arbeiten</li>}
    @if (checkTypeInField('DISABILITY_STATUS')) {<li>Schwerbehinderung</li>}
    @if (checkTypeInField('ORG_UNIT')) {<li>Bereich/Abteilung</li>}
    @if (checkTypeInApprover('CHIEF') || checkTypeInApprover('CHIEF_AND_DEPUTY')) {<li>Vorgesetzter (Vorname, Nachname, AD Benutzername, ARD UID, E-Mail-Adresse)</li>}
    @if (checkTypeInApprover('CHIEF_AND_DEPUTY')) {<li>Stellvertretender Vorgesetzter (Vorname, Nachname, AD Benutzername, ARD UID, E-Mail-Adresse)</li>}
    @if (checkTypeInField('COST_CENTRE') || checkTypeInApprover('COST_CENTRE_RESPONSIBLE') || checkTypeInApprover('COST_CENTRE_RESPONSIBLE_AND_DEPUTY')) {<li>Kostenstelle</li>}
    @if (checkTypeInApprover('COST_CENTRE_RESPONSIBLE') || checkTypeInApprover('COST_CENTRE_RESPONSIBLE_AND_DEPUTY')) {<li>Kostenstellenverantwortlicher (Vorname, Nachname, AD Benutzername, ARD UID, E-Mail-Adresse)</li>}
    @if (checkTypeInApprover('COST_CENTRE_RESPONSIBLE_AND_DEPUTY')) {<li>Stellvertretender Kostenstellenverantwortlicher (Vorname, Nachname, AD Benutzername, ARD UID, E-Mail-Adresse)</li>}
    @if (checkTypeInApprover('DEPARTMENT_CHIEF') || checkTypeInApprover('DEPARTMENT_CHIEF_AND_DEPUTY')) {<li>Abteilung</li>}
    @if (checkTypeInApprover('DEPARTMENT_CHIEF') || checkTypeInApprover('DEPARTMENT_CHIEF_AND_DEPUTY')) {<li>Abteilungsleiter (Vorname, Nachname, AD Benutzername, ARD UID, E-Mail-Adresse)</li>}
    @if (checkTypeInApprover('DEPARTMENT_CHIEF_AND_DEPUTY')) {<li>Stellvertretender Abteilungsleiter (Vorname, Nachname, AD Benutzername, ARD UID, E-Mail-Adresse)</li>}
    @if (checkTypeInApprover('MAIN_DEPARTMENT_CHIEF') || checkTypeInApprover('MAIN_DEPARTMENT_CHIEF_AND_DEPUTY')) {<li>Hauptabteilung</li>}
    @if (checkTypeInApprover('MAIN_DEPARTMENT_CHIEF') || checkTypeInApprover('MAIN_DEPARTMENT_CHIEF_AND_DEPUTY')) {<li>Hauptabteilungsleiter (Vorname, Nachname, AD Benutzername, ARD UID, E-Mail-Adresse)</li>}
    @if (checkTypeInApprover('MAIN_DEPARTMENT_CHIEF_AND_DEPUTY')) {<li>Stellvertretender Hauptabteilungsleiter (Vorname, Nachname, AD Benutzername, ARD UID, E-Mail-Adresse)</li>}
    @if (checkTypeInApprover('DIRECTOR') || checkTypeInApprover('DIRECTOR_AND_DEPUTY')) {<li>Direktion</li>}
    @if (checkTypeInApprover('DIRECTOR') || checkTypeInApprover('DIRECTOR_AND_DEPUTY')) {<li>Direktor (Vorname, Nachname, AD Benutzername, ARD UID, E-Mail-Adresse)</li>}
    @if (checkTypeInApprover('DIRECTOR_AND_DEPUTY')) {<li>Stellvertretender Direktor (Vorname, Nachname, AD Benutzername, ARD UID, E-Mail-Adresse)</li>}
  </ul>
}
@if (checkTypeInField('ROOM')) {
  <p class="text-underline">Speedikon</p>
  <ul>
    <li>Raumnummer</li>
    <li>Gebäudename</li>
    <li>Gebäudeabkürzung</li>
    <li>Etage</li>
    <li>Objekt ID des Raums</li>
    <li>Vorname</li>
    <li>Nachname</li>
    <li>E-Mail-Adresse</li>
  </ul>
}
@if (checkTypeInField('TELEPHONE') || checkTypeInField('MOBILE') || checkTypeInField('FAX')) {
  <p class="text-underline">Telefonbuch</p>
  <ul>
    <li>Vorname</li>
    <li>Nachname</li>
    <li>E-Mail-Adresse</li>
    @if (checkTypeInField('TELEPHONE')) {<li>Telefonnummer</li>}
    @if (checkTypeInField('FAX')) {<li>Faxnummer</li>}
    @if (checkTypeInField('MOBILE')) {<li>Mobilfunknummer</li>}
  </ul>
}
@if (checkTypeInField('FILESERVICE') || checkTypeInField('APPLICATION') || checkTypeInField('PROJECT') || checkTypeInField('CAD') || checkTypeInField('CONFLUENCE') || checkTypeInField('GENERAL') || checkTypeInField('IT') || checkTypeInField('JIRA') || checkTypeInField('BIMEDIAL') || checkTypeInField('MCLOUD') || checkTypeInField('MUSIC_MASTER') || checkTypeInField('RABBIT')) {
  <p class="text-underline">MIT-Serviceportal</p>
  <ul>
    <li>Applikationen</li>
    <li>Rollen/Gruppen/Bereiche/Projekte</li>
  </ul>
}
@if (checkTypeInField('PRODUCTION_UNIT')) {
  <p class="text-underline">i-doit</p>
  <ul>
    <li>Produktionseinheit (Bezeichnung, SYSID)</li>
  </ul>
}


<p class="fw-bold">Rechtsgrundlage</p>
@if (form?.legalBasis) {
  <p [innerHTML]="prepareLink(form?.legalBasis)" [class.bg-warning]="form && form.lastApproved && form.lastApproved.legalBasis !== form.legalBasis"></p>
} @else {
  <p>Rechtsgrundlage für die Verarbeitung der personenbezogenen Daten ist § 46 rbb-StV i.V.m. § 18 BerlDSG i.V.m. § 26 BDSG bzw. Art. 6 Abs. 1 b) DSGVO für freie Mitarbeiterinnen und Mitarbeiter.</p>
}

@if (form?.dataTransmission) {
  <p class="fw-bold">Datenweitergabe</p>
  <p [innerHTML]="prepareLink(form?.dataTransmission)" [class.bg-warning]="form && form.lastApproved && form.lastApproved.dataTransmission !== form.dataTransmission"></p>
}
@if (!form?.dataTransmission && !form?.externalDataTransmission) {
  @if (!form?.actionType || form?.actionType === ActionType.OTRS || form?.actionType === ActionType.OTRS_WEBSERVICE) {
    <p class="fw-bold">Datenweitergabe</p>
  }
  @if (!form?.actionType) {
    <p [class.bg-warning]="form && form.lastApproved && form.lastApproved.actionType !== form.actionType">Die Daten werden ausschließlich innerhalb der Applikation rbb Forms verarbeitet und nicht an interne oder externe Stellen weitergeleitet.</p>
  }
  @if (form?.actionType === ActionType.OTRS || form?.actionType === ActionType.OTRS_WEBSERVICE) {
    <p [class.bg-warning]="form && form.lastApproved && form.lastApproved.actionType !== form.actionType">Die Daten werden zur weiteren Bearbeitung des Antrags an das ARD-Ticketsystem der HA Mediensysteme und IT geschickt. Für die weitere Verarbeitung der Daten gilt die entsprechende Datenschutzerklärung: <a
       href="https://ardzsd.de/otrs/customer.pl?Action=CustomerFAQZoom;ItemID=1589" target="_blank">https://ardzsd.de/otrs/customer.pl?Action=CustomerFAQZoom;ItemID=1589</a></p>
  }
}

@if (form?.externalDataTransmission) {
  <p class="fw-bold">Datenweitergabe an externe Stellen</p>
  <p [innerHTML]="prepareLink(form?.externalDataTransmission)" [class.bg-warning]="form && form.lastApproved && form.lastApproved.externalDataTransmission !== form.externalDataTransmission"></p>
}
@if (!form?.externalDataTransmission && !form?.dataTransmission && (form?.actionType === ActionType.OTRS || form?.actionType === ActionType.OTRS_WEBSERVICE)) {
  <p class="fw-bold">Datenweitergabe an externe Stellen</p>
  <p>Mit der Speicherung des Antrags im ARD-Ticketsystem hat auch der zentrale Servicedesk der ARD lesenden Zugriff auf die Daten.</p>
}

<p class="fw-bold">Datenspeicherdauer</p>
<p [class.bg-warning]="form && form.lastApproved && form.lastApproved.storagePeriod !== form.storagePeriod">Die Daten des Formulars werden ab der Bearbeitung des Formulars bis zum Ende des Kalenderjahres plus {{form?.storagePeriod}} @if (form?.storagePeriod === 1) {Jahr} @else {Jahre} aufbewahrt. Dazugehörige Logdaten werden über denselben Zeitraum wie das Formular selbst gespeichert. Die Aufbewahrung dient zur sicheren Nachverfolgung, Überprüfung und Archivierung von Anträgen. Die Löschung erfolgt nach dem Aufbewahrungszeitraum automatisch durch das System. Sie können ihre ausgefüllten Formulare während der Aufbewahrungsfrist zu jeder Zeit wieder aufrufen, um die erhobenen Daten zu sehen. Des Weiteren können dies ebenfalls die Genehmiger des Formulars, sowie die den Antrag bearbeitende Fachabteilung.</p>



<p class="fw-bold">Rechte der Betroffenen</p>
<p [class.bg-warning]="form && form.lastApproved && form.lastApproved.orgUnitName !== form.orgUnitName">Sie haben das Recht, von der
  @switch (form?.orgUnitType) {
    @case (OrgUnitType.MAIN_DEPARTMENT) {Hauptabteilung}
    @case (OrgUnitType.DEPARTMENT) {Abteilung}
  }
  {{form?.orgUnitName}} Auskunft über die Sie betreffenden personenbezogenen Daten im
  Zusammenhang mit diesem Formular, sowie ggf. Berichtigung, Löschung und Einschränkung der Verarbeitung der Daten zu verlangen. Sie haben ggf. auch das Recht, einen Widerspruch gegen die Verarbeitung geltend zu machen
  (Betroffenenrechte gem. Art. 15 ff. DSGVO).</p>
<p>Entsprechende Begehren richten Sie bitte an die:</p>
<p class="ps-3" [class.bg-warning]="form && form.lastApproved && (form.lastApproved.contactEmail !== form.contactEmail || form.lastApproved.contactTelephone !== form.contactTelephone)">
  @switch (form?.orgUnitType) {
    @case (OrgUnitType.MAIN_DEPARTMENT) {Hauptabteilung}
    @case (OrgUnitType.DEPARTMENT) {Abteilung}
  }
  {{form?.orgUnitName}}<br>
  E-Mail: <a target="_blank" href="mailto:{{form?.contactEmail}}">{{form?.contactEmail}}</a>
  @if (form?.contactTelephone) {
    <br>Telefon: @if (form?.contactTelephone?.length === 5) {+49 30 97993} {{form?.contactTelephone}}
  }
</p>
<p>Sie haben gemäß Art. 77 DSGVO das Recht, sich bei der Aufsichtsbehörde zu beschweren, wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer personenbezogenen Daten nicht rechtmäßig erfolgt. Aufsichtsbehörde ist</p>
<p class="ps-3">
  der Rundfunkdatenschutzbeauftragte für den Datenschutz beim BR, HR, MDR, rbb, SR, SWR, WDR, Deutschlandradio und ZDF<br>
  Stephan Schwarze<br>
  Kantstraße 71-73<br>
  04275 Leipzig<br>
  E-Mail: <a target="_blank" href="mailto:kontakt@rundfunkdatenschutz.de">kontakt&#64;rundfunkdatenschutz.de</a>
</p>


<p class="fw-bold">Weitere Hinweise</p>
<p>Für feste und freie Mitarbeiter des rbb finden die Regelungen aus der allgemeinen <a href="https://rbb.sharepoint.com/:b:/r/sites/Intranet-Datenschutz/Freigegebene Dokumente/Datenschutzerkl%C3%A4rungen/Datenschutzerkl%C3%A4rung - HA Personal.pdf">Datenschutzinformation der HA Personal</a> Anwendung.</p>
<p>Des Weiteren ist bei der Nutzung von Eigenentwicklungen des Bereichs Infrastruktur Software die <a href="https://tools.rbb-online.de/home/privacy" target="_blank">Datenschutzerklärung von rbb Tools</a> zu beachten.</p>
